var $24d65dbbedc50cf8$exports = {};
$24d65dbbedc50cf8$exports = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};


export {$24d65dbbedc50cf8$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
